import { createContext } from "react";
import { CanvasTexture } from "three";

const ProductTextureContext = createContext<[CanvasTexture, CanvasTexture|undefined]>([new CanvasTexture(new OffscreenCanvas(1024, 1024)), undefined])

export default ProductTextureContext